import React from 'react'
import yup from 'yup'
import Form from 'react-formal'
import { Link } from 'react-router'
import UsernameImage from '../../../img/icons/general-icons/user_icon.png'
import PasswordImage from '../../../img/icons/general-icons/password_icon.png'

var loginSchema = yup.object({
  email: yup.string().email('Ingrese un email valido').required('Ingrese su email'),
  password: yup.string().required('Ingrese su contraseña')
})

export default class LoginForm extends React.Component {
  constructor (props) {
    super(props)
    this.state = ({ model: {} })
  }

  login (e) {
    e.preventDefault()
    let email = this.state.model.email
    let passw = this.state.model.password
    this.props.login(email, passw)
  }

  render () {
    return (
      <Form id='loginForm' className='form' schema={loginSchema} value={this.state.model} onChange={model => this.setState({ model })}>
        <div className='form-field-container'>
          <img className='form-field-image' src={UsernameImage} />
          <Form.Field name='email' id='email' ref='email' type='text' className='form-field-input' placeholder='Email' />
          <Form.Message className='message' for='email'/>
        </div>
        <div className='form-field-container'>
          <img className='form-field-image' src={PasswordImage} />
          <Form.Field name='password' id='password' ref='password' type='password' className='form-field-input' placeholder='Contraseña' />
          <Form.Message className='message' for='password'/>
        </div>
        <div className='form-submit-btn-container'>
          <Form.Button type='submit' id='loginUser' className='form-submit-button' onClick={this.login.bind(this)}>Ingresar</Form.Button>
        </div>
        <div className='form-field-link-container'>
          <Link className='form-field-link' to={'/forgot'}>¿Olvidaste la contraseña&#63;</Link>
        </div>
      </Form>
    )
  }
}

/* Validate props */
LoginForm.propTypes = {
  login: React.PropTypes.func
}



// WEBPACK FOOTER //
// ./src/components/Account/Login/LoginForm.js